import { PageLayout } from '@/components/UI/Layouts/Admin/PageLayout';
import { ROUTES } from '@/config/routes';
import { useCreateOne } from '@/queries/admin';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { Form, FormData } from './Form';

export const Create = () => {
  const navigate = useNavigate();
  const { mutateAsync: createChat } = useCreateOne('chats');

  const onSubmit = async (data: FormData) => {
    try {
      await createChat({
        data: {
          ...data,
          userId: data.type === 'public' ? null : data.userId || null,
        },
      });
      toast.success('Чат успешно создан');
      navigate(ROUTES.ADMIN.CHATS);
    } catch (error) {
      console.error('Error creating chat:', error);
      toast.error('Произошла ошибка при создании чата');
    }
  };

  return (
    <PageLayout
      breadcrumbs={[
        {
          label: 'Чаты',
          href: ROUTES.ADMIN.CHATS,
        },
        {
          label: 'Создание',
          href: '',
        },
      ]}
    >
      <Form onSubmit={onSubmit} />
    </PageLayout>
  );
};
